import { render } from "./AddInvoice.vue?vue&type=template&id=38412f63&scoped=true"
import script from "./AddInvoice.vue?vue&type=script&lang=js"
export * from "./AddInvoice.vue?vue&type=script&lang=js"

import "./AddInvoice.vue?vue&type=style&index=0&id=38412f63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38412f63"]])

export default __exports__